"use strict";

exports.__esModule = true;
exports.default = void 0;

var _constants = require("../configs/constants");

var css = "\n  font-family: var(--BlueConfigGlobalFontFamily, " + _constants.FONT_FAMILY + ");\n";
var _default = css;
exports.default = _default;